import React from "react";

import { League } from "../../models/Leagues";

import WeeklyAnalyticsItem from "../atoms/WeeklyAnalyticsItem";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import {
    hasLifetimeSub,
    hasPremiumSub,
} from "../../helpers/checkSubscriptions";

interface WeeklyListAnalyticsProps {
    league?: League;
    item: any; //Cast | TeamLeagueTeams
    setUpTeam?: boolean;
    question?: boolean;
}

const WeeklyListAnalytics: React.FC<WeeklyListAnalyticsProps> = ({
    item,
    league,
    setUpTeam,
    question,
}) => {
    const subscription = useSelector((state: RootState) => state.subscription);

    if (
        subscription &&
        (hasPremiumSub(subscription.name) || hasLifetimeSub(subscription.name))
    ) {
        if (question) {
            return (
                <WeeklyAnalyticsItem
                    siteValue={item.site_question}
                    leagueValue={item.league_question}
                />
            );
        } else {
            return (
                <div className="pt-2" style={{ fontSize: 14 }}>
                    {(league?.draft_type === "Team" ||
                        league?.draft_type === "Weekly Redraft" ||
                        league?.draft_type === "Weekly Budget") &&
                        item.average && (
                            <div>
                                Average Score: <b>{item.average.toFixed(2)}</b>
                            </div>
                        )}
                    {league?.draft_type === "Team" && setUpTeam && (
                        <WeeklyAnalyticsItem
                            primaryText="Starting"
                            siteValue={item.team_started}
                            leagueValue={item.team_started_league}
                        />
                    )}
                    {league?.draft_type === "Team" && !setUpTeam && (
                        <WeeklyAnalyticsItem
                            primaryText="Owned"
                            siteValue={item.team_owned}
                            leagueValue={item.team_owned_league}
                        />
                    )}
                    {league?.draft_type === "Weekly Redraft" && (
                        <WeeklyAnalyticsItem
                            primaryText="Starting"
                            siteValue={item.weekly_started}
                            leagueValue={item.weekly_started_league}
                        />
                    )}
                    {league?.draft_type === "Weekly Budget" && (
                        <WeeklyAnalyticsItem
                            primaryText="Starting"
                            siteValue={item.weekly_budget_started}
                            leagueValue={item.weekly_budget_started_league}
                        />
                    )}
                    {(league?.draft_type === "Confidence Pool" ||
                        league?.draft_type ===
                            "Eliminated Confidence Pool") && (
                        <div>
                            Average Rank:{" "}
                            <b>
                                {item.average
                                    ? parseFloat(item.average).toFixed(2)
                                    : "0.00"}
                            </b>
                        </div>
                    )}
                </div>
            );
        }
    }

    return null;
};

export default WeeklyListAnalytics;
